import enLang from './entries/en_US';
import hkLang from './entries/zh_HK';

const AppLocale = {
  en: enLang,
  hk: hkLang
};

export default AppLocale;
